/**************************************************
 * Nombre:       Login
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import './login.css'
import fondo from '../Recursos/video_sistema.mp4'
import logo from '../Recursos/logo_oscuro.svg'
import Ingreso from "./Ingreso";
import {useEffect, useState} from "react";
import {ArrowBack} from "@mui/icons-material";
import Registro from "./Registro";
import {useResponsive} from "../Modulo_Responsive/Hooks/useResponsive";
import logoOscuro from '../Recursos/logo_largo_oscuro.svg'
import {obtenerVariableUlr} from "../Utilidades/obtenerVariableUlr";
import {irUrl} from "../Utilidades/irUrl";
import {URLPAGINA} from "../Constantes";

const Login = () => {
    const {sCell, sTab} = useResponsive()
    const [esRegistro, setEsRegistro] = useState(false)


    useEffect(() => {
        let tipo = obtenerVariableUlr('tipo')
        if (tipo === 'registro') {
            setEsRegistro(true)
        }
    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <video width={'100%'} height={'100vh'}
                   style={{
                       objectFit: 'cover',
                       zIndex: 1,
                       height: '100vh',
                   }}
                   id="background-video" autoPlay loop muted>
                <source src={fondo} type="video/mp4"/>
            </video>


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, zIndex: 2, mt: sCell ? -100 : sTab ? -140 : -90}}
            >

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <img src={logo} width={250} height={'auto'}/>
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-end'}}>
                    <Button
                        onClick={() => irUrl(URLPAGINA)}
                        startIcon={<ArrowBack/>}>{sCell ? 'Ir a Pagina' : 'Regresar a Pagina'}</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 4}} sx={{justifyContent: 'flex-start', mt: 10, zIndex: 2}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{backgroundColor: '#fff', p: 3, borderRadius: 2, boxShadow: 4}}
                    >

                        {esRegistro ?
                            <Registro setEsRegistro={setEsRegistro}/>
                            :
                            <Ingreso setEsRegistro={setEsRegistro}/>
                        }


                    </Grid>
                </Grid>


            </Grid>
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: -10, zIndex: 1}}>
                <img src={logoOscuro} width={sCell ? 180 : 250} height={'auto'}/>
            </Grid>

        </Grid>
    )

}
export default Login    